export const navBarHeightTransition = 'all 0.5s ease-in-out'

export const DEFAULT_NAVBAR_HEIGHT = 64
// includes added search bar of 36px and gap of 12px. 64 + 36 + 12 = 112
export const EXPANDED_NAVBAR_HEIGHT = 112
